import type { ProcedureProviderInputType } from 'types/providers'

export enum ProceduresFields {
  PREFIX = 'durationData',
  NAME = 'name',
  DESCRIPTION = 'description',
  MAIN_TIME = 'mainTime',
  BEFORE_TIME = 'beforeTime',
  REQUIRES_CELL_BANK = 'requiresCellBank',
  IS_CELL_BANK = 'isCellBank',
  IS_CELL_BANK_MANUFACTURE = 'isCellBankManufacture',
  NUMBER_OF_CELLS = 'numberOfStemCells',
  CRM_CODE = 'crmCode',
  REQUIRED_PROVIDERS = 'providerTypes',
  RULES = 'schedulingRules',
  PRODUCT_SPECIALTY_ID = 'productSpecialtyId',
  MEDICAL_SERVICE_TYPE = 'medicalServiceType',
  PROCEDURE_TYPE = 'procedureType',
  PROVIDER_TYPE = 'providerType',
  PREPARATION_TYPE = 'preparationType',
  PRE_PREPARATION = 'prePreparation',
  POST_PREPARATION = 'postPreparation',
  SPLIT_PROCEDURES = 'splitProcedures',
  IS_ACTIVE = 'isActive',
}

export enum NewProviderFields {
  CERTIFICATION = 'certification',
  PROVIDER_SPECIALTY_ID = 'providerSpecialtyId',
  COUNT = 'count',
}

export const newProvider: ProcedureProviderInputType = {
  [NewProviderFields.CERTIFICATION]: null,
  [NewProviderFields.PROVIDER_SPECIALTY_ID]: null,
  [NewProviderFields.COUNT]: 1,
}
